export const engagementAppGroupIdTestSendFreeTrialAllowedDomains =
  "/engagement/:app_group_id/test_send/free_trial_allowed_domains";
